var $ = require('jquery');
(function () {
    'use strict';
    var selectors = {
        logoAreaContainer: 'div#edit-website-logo',
        openEditorLink: 'a.open-editor',
        editor: 'div#diye-logo-editor',
        logoArea: 'div#website-logo',

        editorSaveButton: '#diye-logo-editor-save',
        editorCancelButton: '#diye-logo-editor-cancel'
    },

    defaultOptions = {
        sidebarWidth:   100,
        speed:          100,
        slideTimeout:  2000,
        duration:       300
    };

    var $elements = {
        logoAreaContainer   : null,
        openEditorLink      : null,
        logoAreaOverlay     : null,
        editor              : null,
        logoArea            : null
    },
    isOpened= false,
    data= null,
    editorInitialized = false;

    /**
     * sets controllable elements
     */
    var setEnvironment = function () {
        $elements = $.extend({}, $elements, {
            logoAreaContainer: $(selectors.logoAreaContainer),
            openEditorLink: $(selectors.openEditorLink, $elements.logoAreaContainer),
            editor: $(selectors.editor),
            logoArea: $(selectors.logoArea, $elements.logoAreaContainer)
        });
    };

    /**
     * keeps overlay above logo area so the links are not clickable
     * also used for opening editor
     */
    var placeOverLay = function() {

        var
            $logoAreaContainer = $(selectors.logoAreaContainer),
            $logoImageAnchor = $logoAreaContainer.find('.website-logo-image-anchor'),
            $logoText, $logoOverlayGuide
        ;

        if ($logoImageAnchor.is(':visible')) {
            $logoOverlayGuide = $logoImageAnchor;
        } else {
            $logoText = $logoAreaContainer.find('.website-logo-text');
            if ($logoText.is(':visible')) {
                $logoOverlayGuide = $logoText;
            } else {
                $logoOverlayGuide = $logoAreaContainer.find('.logo-upload-image-container')
            }
        }

        var
            guideOffs = $logoOverlayGuide.offset(),
            guideW = $logoOverlayGuide.outerWidth(),
            guideH = $logoOverlayGuide.outerHeight(),
            overlayW = Math.max(160, guideW),
            overlayH = Math.max(30, guideH),
            overlayT = guideOffs.top - (overlayH - guideH)/2,
            overlayL = guideOffs.left - (overlayW - guideW)/2
        ;

        $elements.logoAreaOverlay
            .show()
            .offset({left: overlayL, top: overlayT})
            .width(overlayW)
            .height(overlayH);
    };

    var init = function (logoData) {
        setEnvironment();
        data=logoData;

        cms.common.util.EventingMixin.mixin(this);

        var
            timeout,
            self = this
            ;

        if ($elements.logoAreaContainer.length == 0) {
            return false;
        }

        placeEditor();

        $elements.logoAreaOverlay
            //.add($elements.openEditorLink)
            .multihover(
            function () {
                if (!isOpened) {
                    clearTimeout(timeout);
                    showEditButton(defaultOptions.speed);
                }
            },
            function () {
                if (!isOpened) {
                    clearTimeout(timeout);
                    timeout = setTimeout(
                        function () {
                            hideEditButton(defaultOptions.speed);
                        },
                        defaultOptions.slideTimeout
                    );
                }
            }
        );

        $elements.openEditorLink.button();

        $(selectors.editorCancelButton, $elements.editor)
            .button()
            .click(function () {
                hideEditor();
            });

        $(selectors.editorSaveButton, $elements.editor).button();

        $elements.openEditorLink
            .add($elements.logoAreaOverlay)
            .add($elements.logoArea.find('.logo-upload-image'))
            .click(function (e){
                e.preventDefault();
                openEditor();
            });

        // reposition editor on window resize
        $(window).resize(function () {
            placeEditor();
        });
        // apply overlay after the page loads (there are boundaries set within layout css)
        // that have to be loaded and after that area get it's final dimensions
        $(window).load(function () {
            placeOverLay();
        });
    };

    /**
     * places logo editor below the logo element
     */
    var placeEditor = function () {
        var editorWidth = $elements.logoAreaContainer.outerWidth();

        if (typeof($elements.logoAreaContainer) == 'object' && $elements.logoAreaContainer.offset) {
            $elements.editor.offset = $elements.logoAreaContainer.offset();
        }
        $elements.editor.css({
            top: $elements.logoArea.innerHeight() + $elements.logoArea.offset().top,
            /* in case it's ie8, outerWidth - width gets us the border width on both sides */
            width: ($elements.logoAreaContainer.size().width > editorWidth ? $elements.logoAreaContainer.size().width : editorWidth) - ($.isBrowser.ie8 ? $elements.editor.outerWidth() - $elements.editor.width() : 0),
            left: $elements.logoArea.offset().left + editorWidth + defaultOptions.sidebarWidth > $(window).width() ?
                (
                    (editorWidth - $elements.logoAreaContainer.size().width) < $elements.editor.offset.left ?
                        $elements.editor.offset.left - (editorWidth - $elements.editor.size.width) :
                        $elements.editor.offset.left
                    ) :
                $elements.editor.offset.left
        });

        if (!$elements.logoAreaOverlay) {
            $elements.logoAreaOverlay = $elements.openEditorLink.wrap(
                $('<div class="logo-area-overlay"></div>').css({
                    'position': 'absolute',
                    'top': '0',
                    'left': '0'
                })
            ).parent();
        }

        placeOverLay();
    };

    var showEditButton = function (duration) {
        $elements.openEditorLink.slideDown(duration);
    };

    var hideEditButton = function (duration) {
        $elements.openEditorLink.slideUp(duration, function () {});
    };

    var openEditor = function () {

        Modul.abortEditingModules();

        if (isOpened) {
            return false;
        }

        isOpened = true;
        hideEditButton(0);

        $elements.logoAreaContainer.addClass('opened').removeClass('closed');

        $elements.editor.slideDown(defaultOptions.speed, function () {
            focusEditor();
        });

        /* track that the eh item has been clicked */
        $(document).trigger('diy-editor-generic-sectionAccessed', {
            sectionCodeName: 'logo-editor'
        });

        $(document.body).trigger('LogoOpened.BSA');   // @toDo this needs to be defined

        if (!editorInitialized) {
            editorInitialized = true;
            initEditorApp();
        }

        return true;
    };

    var focusEditor = function () {
        $elements.editor.scrollIntoView();
    };

    var hideEditor = function () {
        if (!isOpened) {
            return false;
        }
        isOpened = false;
        // scroll up to the editor
        $elements.editor.slideUp(defaultOptions.speed, function () {
            $elements.logoAreaContainer.scrollIntoView();
        });

        $elements.logoAreaContainer.addClass('closed').removeClass('opened');

//                jQuery(window).history('add', 'logo-close');
        return true;
    };

    var initEditorApp = function () {

        $elements.logoArea.find('.logoApp-show, .logoApp-hide').removeClass('logoApp-show logoApp-hide');
        $elements.logoArea.find('.website-logo-image')
            .removeAttr('width')
            .load(function(){
                placeEditor();
            });

        $elements.editor.find('.eh-logo-maker').bind('click', function() {
            $(document).trigger('diy-editor-generic-linkInteraction', {
                'pageName': 'Logo Area',
                'actionName': 'logoMakerLogo'
            });
        });

        $elements.editor.find('#logo-upload-cstok').val(jimdoData.cstok);
        diy.module.logo.app.bootstrap($elements.editor.get(0));
        diy.module.logo.app.init(data);

        diy.module.logo.previewApp.bootstrap(jQuery('#edit-website-logo').get(0));
        diy.module.logo.previewApp.init(data);
    };
    var $resizeHelper = null;

    var loadData = function(previewData) {
        data = previewData;
        if (!editorInitialized) {
            editorInitialized = true;
            initEditorApp();
        } else {
            updatePreview(data);
            diy.module.logo.app.init(data);
        }
    };

    var updatePreview = function(previewData) {
        if (previewData._disableSync == true) {
            showResizeHelper(previewData);
        } else {
            diy.module.logo.previewApp.repaint(previewData);

            var timeout;
            setTimeout(function(){
                if($resizeHelper) {
                    $resizeHelper.unwrap().remove();
                    $resizeHelper = null;
                }
                placeEditor();
                clearTimeout(timeout);
            }, 200);
        }
    };

    var showResizeHelper = function(previewData) {

            if($resizeHelper === null) {
                $resizeHelper = $('<div class="logomodule-resize-helper"/>')
                    .appendTo(document.body)
                    .wrap("<div class='diye'></div>");
                $resizeHelper.offset($elements.logoArea.offset());
                $resizeHelper.width($elements.logoArea.width());
            }

            var logoHeight;
            if (previewData.type === 'image') {
                // Use the current image size
                logoHeight = previewData.imageHeight;
            } else {
                // The height of the text is fixed while resizing
                logoHeight = $elements.logoArea.height();
            }

            var applyCss = {
                // height is calculated from the image/text height + top and bottom spacing
                height: logoHeight + (2 * previewData.logoSpacing) + 'px'
            };

            $resizeHelper.css(applyCss);
    };
    var getLogoImageEl = function() {
        var imgEl;

        // we don't always have the logo area - if that happens the return is obvious //
        if (!$elements || !$elements.logoArea) {
            return null;
        }

        imgEl = $elements.logoArea.find('.website-logo-image:visible');

        if (imgEl.length) {
            return imgEl;
        }
        return null;
    };

    var logoExists = function() {
        return $elements && $elements.logoArea;
    }

    return jQuery.extend(this, {
        init: init,
        placeEditor: placeEditor,
        hideEditor: hideEditor,
        openEditor: openEditor,
        focusEditor: focusEditor,
        updatePreview: updatePreview,
        loadData: loadData,
        getLogoImageEl: getLogoImageEl,
        logoExists: logoExists
    });

}).call(exports);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/module/logo/js/Logo.js
 ** module id = 1138
 ** module chunks = 0
 **/